module.exports = __webpack_public_path__ + "img/apple_store.0333bd2e.png";